export default __webpack_public_path__ + "static/char-thumb-42-4dc040e94cb76af3eb91ac7088f2757d.png";